
<template>
    <div>
        <Hero>
            <template #breadcrumb>
                <div />
            </template>
            <template #title>
                <div class="hero__title">
                    <h1>{{ showNavigationError.route?.meta?.title }}</h1>
                </div>
            </template>
        </Hero>
        <al-empty-state
            variant="NO-PERMISSIONS"
            size="big"
            title="Access Denied"
            subtitle="It seems like you don't have access to this content. Please check that you are logged in with the correct account."
        >
            <al-button
                variant="primary"
                @click="goHome"
            >
                Go to home
            </al-button>
        </al-empty-state>
    </div>
</template>

<script setup lang="ts">
import { showNavigationError } from '../../../store/errorState';
import { Hero } from '../Commons/UI/molecules';
import '@playvox/almendra/dist/components/button';
import '@playvox/almendra/dist/components/empty-state';

const goHome = () => {
    window.location.href = '/';
};
</script>
